var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{staticClass:"cp-page__wrapper"},[_c('div',{staticClass:"cp-main-inner__wrapper"},[_c('title-page',[_vm._v("Страница не найдена")]),_c('div',{staticClass:"cp-page-not-found"},[_c('span',[_vm._v("404")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }